<template>
    <nav class="rc-lang" :class="{'rc-lang--light': light}" :aria-label="$t('layout.language.menu')">
        <template v-for="(item, index) in locales" :key="item.value">
            <span v-if="index > 0" class="rc-lang__sep" aria-hidden="true">|</span>
            <button type="button"
                    class="rc-lang__item"
                    :class="{'rc-lang__item--active': item.value === locale}"
                    :lang="item.tag"
                    :title="$t('layout.language.switch_to', {language: item.name})"
                    :aria-label="item.name"
                    :aria-pressed="item.value === locale"
                    @click="setLocale(item.value)">
                {{ item.label }}
            </button>
        </template>
    </nav>
</template>

<script setup>
/**
 * Das Sprachmenü: DE | EN als Text, nicht als Flagge.
 *
 * Sitzt rechts in der dunklen Systemleiste, auf der Anmeldeseite im Fuß.
 * Die Wahl landet im localStorage, siehe resources/js/i18n.
 */
import {useI18n} from "../i18n";

defineProps({
    // Für helle Flächen, etwa den roten Hintergrund der Anmeldeseite.
    light: {type: Boolean, default: false},
});

const {locale, locales, setLocale} = useI18n();
</script>

<style scoped lang="scss">
.rc-lang {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.rc-lang__sep { opacity: .45; }

.rc-lang__item {
    background: none;
    border: 0;
    padding: 2px 2px;
    color: inherit;
    font: inherit;
    letter-spacing: .06em;
    cursor: pointer;
    opacity: .7;

    &:hover,
    &:focus-visible { opacity: 1; text-decoration: underline; text-underline-offset: 3px; }
}

.rc-lang__item--active {
    opacity: 1;
    font-weight: 700;
    color: var(--rc-page);
    cursor: default;

    &:hover { text-decoration: none; }
}

.rc-lang--light .rc-lang__item--active { color: inherit; }

// Auf dem Telefon mit dem Daumen treffbar, wie alle Knöpfe im Redesign.
@media (max-width: 900px) {
    .rc-lang__item { min-width: 40px; min-height: 32px; }
}
</style>
